import React from 'react';
import { getCustomizedStructure } from 'utils/common';
import ComponentNoDataFound from 'components/ComponentNoDataFound';
import FolderName from './FolderName';
import FileName from './FileName';
export default function FolderStructure({
  activeEventKey,
  setActiveEventKeyAccordian,
  folderStructure,
  handleFolderClick,
  downloadArtefactLink,
}) {
  return (
    <div onToggle={setActiveEventKeyAccordian}>
      {folderStructure?.files?.length > 0 ? (
        folderStructure.files.map((folder, index) => {
          return (
            <div key={index}>
              {folder.type === 'folder' ? (
                <div>
                  <FolderName
                    handleFolderClick={handleFolderClick}
                    folder={folder}
                  />
                  {folder.isOpen && (
                    <div className="ltw-border-l ltw-border-gray-26 ltw-pl-40px">
                      <FolderStructure
                        folderStructure={getCustomizedStructure(folder)}
                        activeEventKey={activeEventKey}
                        setActiveEventKeyAccordian={setActiveEventKeyAccordian}
                        handleFolderClick={handleFolderClick}
                        downloadArtefactLink={downloadArtefactLink}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <FileName
                  folder={folder}
                  downloadArtefactLink={downloadArtefactLink}
                />
              )}
            </div>
          );
        })
      ) : (
        <ComponentNoDataFound
          type="nodataavialable"
          message="No Files/Folder Found"
        />
      )}
    </div>
  );
}
